import { render, staticRenderFns } from "./ButtonSpec.vue?vue&type=template&id=315705f3&scoped=true"
import script from "./ButtonSpec.vue?vue&type=script&lang=js"
export * from "./ButtonSpec.vue?vue&type=script&lang=js"
import style0 from "./ButtonSpec.vue?vue&type=style&index=0&id=315705f3&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315705f3",
  null
  
)

export default component.exports